import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgStepFinalDone = forwardRef(
  (props: Props, svgRef: Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle cx={16} cy={16} r={14.5} stroke="#084" strokeWidth={3} />
      <path
        fill="#084"
        fillRule="evenodd"
        d="M10.125 12.125v8.194h11.75v-8.194h-11.75zM9.889 10A1.889 1.889 0 008 11.889v8.667c0 1.043.846 1.888 1.889 1.888H22.11A1.889 1.889 0 0024 20.556v-8.667A1.889 1.889 0 0022.111 10H9.89z"
        clipRule="evenodd"
      />
      <path
        fill="#084"
        fillRule="evenodd"
        d="M9.382 12.106L16 15.887l6.618-3.781 1.054 1.845-7.145 4.083a1.062 1.062 0 01-1.054 0L8.328 13.95l1.054-1.845z"
        clipRule="evenodd"
      />
    </svg>
  )
);
SvgStepFinalDone.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgStepFinalDone;
